export default "__VITE_ASSET__Dwj_8tQ2__"